import { IMapInstance, IMapProvider, MapInitOptions } from "../map-provider.interface";
import { NoneMapInstance } from "./none-map-instance";

export class NoneProvider implements IMapProvider {
    async createMap(_container: HTMLElement, options: MapInitOptions): Promise<IMapInstance> {
        return new NoneMapInstance();
    }
}